import { Hash, TrendingUp, Type, Calendar } from 'lucide-react';

export const COLORS = ['#3b82f6', '#6366f1', '#f59e0b', '#10b981', '#ef4444', '#8b5cf6', '#ec4899', '#14b8a6'];

export const PALETTES = {
  default: ['#3b82f6', '#6366f1', '#f59e0b', '#10b981', '#ef4444', '#8b5cf6', '#ec4899', '#14b8a6'],
  warm: ['#ef4444', '#f97316', '#f59e0b', '#eab308', '#dc2626', '#ea580c', '#d97706', '#ca8a04'],
  cool: ['#06b6d4', '#14b8a6', '#0ea5e9', '#22d3ee', '#2dd4bf', '#38bdf8', '#67e8f9', '#5eead4'],
  earth: ['#92400e', '#78716c', '#a16207', '#65a30d', '#b45309', '#57534e', '#854d0e', '#4d7c0f'],
  monochrome: ['#e2e8f0', '#cbd5e1', '#94a3b8', '#64748b', '#475569', '#334155', '#1e293b', '#0f172a'],
};

export const TYPE_ICONS = { integer: Hash, float: TrendingUp, string: Type, date: Calendar };

export const TT_STYLE = { background: 'rgba(9,9,11,0.95)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 12, fontSize: 11, color: '#e2e8f0', padding: '12px 16px', minWidth: 160 };
export const TT_LABEL_STYLE = { color: '#e2e8f0', fontWeight: 600, marginBottom: 4 };
export const TT_ITEM_STYLE = { color: '#cbd5e1' };
export const AXIS_PROPS = { tick: { fontSize: 10, fill: '#a1a1aa' }, axisLine: false, tickLine: false };
